export type DraggableTypes = {
  TIMESLOT: 'timeslot';
  POST_EDITOR_MEDIA: 'media';
  TEXT_VARIATION: 'textVariation';
  IG_GRID_CARD: 'igGridCard';
  IG_GRID_PLACEHOLDER: 'igGridCardPlaceholder';
  POST_CARD: 'postCard';
  MENU_TREE_ACTION: 'menuTreeAction';
  MENU_TREE_FOLDER: 'menuTreeFolder';
  MENU_TREE_SOURCE: 'menuTreeSource';
};

export const DraggableTypesObject: DraggableTypes = {
  TIMESLOT: 'timeslot',
  POST_EDITOR_MEDIA: 'media',
  TEXT_VARIATION: 'textVariation',
  IG_GRID_CARD: 'igGridCard',
  IG_GRID_PLACEHOLDER: 'igGridCardPlaceholder',
  POST_CARD: 'postCard',
  MENU_TREE_ACTION: 'menuTreeAction',
  MENU_TREE_FOLDER: 'menuTreeFolder',
  MENU_TREE_SOURCE: 'menuTreeSource'
};

type DraggableKeys = keyof typeof DraggableTypesObject;
export type DraggableValues = (typeof DraggableTypesObject)[DraggableKeys];
